import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartData } from 'chart.js';
import { VendorCategory } from '../../models/dashboard.model';

@Component({
  selector: 'app-category-chart',
  standalone: true,
  imports: [CommonModule, BaseChartDirective],
  templateUrl: './category-chart.component.html',
  styleUrl: './category-chart.component.scss',
})
export class CategoryChartComponent implements OnInit {
  @Input() title = 'Vendor Category Distribution';
  @Input() categories: VendorCategory[] = [];

  doughnutChartOptions: ChartConfiguration<'doughnut'>['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '75%',
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        backgroundColor: '#1F2937',
        titleColor: '#F9FAFB',
        bodyColor: '#F9FAFB',
        padding: 12,
        cornerRadius: 8,
        displayColors: true,
        callbacks: {
          label: (context) => {
            const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
            const percentage = ((context.parsed / total) * 100).toFixed(1);
            return `${context.label}: ${context.parsed} (${percentage}%)`;
          }
        }
      }
    },
    animation: {
      animateRotate: true,
      animateScale: false,
      duration: 1200,
      easing: 'easeOutQuart'
    },
    elements: {
      arc: {
        borderWidth: 0,
        borderRadius: 4
      }
    }
  };

  doughnutChartData: ChartData<'doughnut'> = {
    labels: [],
    datasets: [{
      data: [],
      backgroundColor: [],
      hoverBackgroundColor: [],
      borderWidth: 0,
      hoverOffset: 4
    }]
  };

  ngOnInit() {
    this.updateChartData();
  }

  ngOnChanges() {
    this.updateChartData();
  }

  private updateChartData() {
    if (this.categories && this.categories.length > 0) {
      this.doughnutChartData = {
        labels: this.categories.map(c => c.name),
        datasets: [{
          data: this.categories.map(c => c.count),
          backgroundColor: this.categories.map(c => c.color),
          hoverBackgroundColor: this.categories.map(c => c.color),
          borderWidth: 0,
          hoverOffset: 4
        }]
      };
    }
  }
}
